import { render, staticRenderFns } from "./VMultiTuple.vue?vue&type=template&id=33fc7e86&"
import script from "./VMultiTuple.vue?vue&type=script&lang=ts&"
export * from "./VMultiTuple.vue?vue&type=script&lang=ts&"
import style0 from "./VMultiTuple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports